import { emailThreadContracts } from "./email-threads.contract";
import { outboundEmailContracts } from "./outbound-emails.contract";
import { inboundEmailContracts } from "./inbound-emails.contract";
import { emailRulesContracts } from "./email-rules.contract";
import { emailDraftContracts } from "./email-drafts.contract";

/**
 * Communications module contracts
 */
export const communicationsContracts = {
  emailThreads: emailThreadContracts,
  outboundEmails: outboundEmailContracts,
  inboundEmails: inboundEmailContracts,
  emailRules: emailRulesContracts,
  emailDrafts: emailDraftContracts,
} as const;

// Re-export types
export * from "./email-threads.contract";
export * from "./outbound-emails.contract";
export * from "./inbound-emails.contract";
export * from "./email-rules.contract";
export * from "./email-drafts.contract";
